import { render } from "./Advisor.vue?vue&type=template&id=5584040e"
import script from "./Advisor.vue?vue&type=script&lang=js"
export * from "./Advisor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__